function Header() {
  return (
    <div id="header">
      <h1>Todo List</h1>
    </div>
  );
}

export default Header;
